// import React, { useState, useEffect } from "react";
// import { Form, Input, Upload, Button, message, Typography, Row, Col, Spin, Tooltip, Modal, InputNumber, Card, Divider, notification } from "antd";
// import { UploadOutlined, DownloadOutlined, CheckCircleOutlined, FileExcelOutlined, FileExcelFilled, ExclamationCircleOutlined, LeftOutlined, RightOutlined, FilePdfOutlined } from "@ant-design/icons";
// import LeftLayout from "../../pageHeader/LeftLayout";
// import SidebarLayoutConsumer from "../Administrator/SidebarLayoutConsumer";
// import _consumerService from "../../../modules/consumerService";
// import { useHistory, useLocation } from "react-router-dom";
// import { COMMON_ERROR_MSG } from "../../../constants/constants";
// import { routes } from "../../../routes/Routes";
// import IntegerInput from "../../../components/IntergerInput";
// import DocumentUploadCard from "../../../components/DocumentUploadCard";
// //import IntegerInput from "../../components/IntergerInput";
// import ConsumerApplicationProgressBar from "../Consumer/ConsumerApplicationProgressBar";
// import ConsumerShowApplicationId from "../Consumer/ConsumerShowApplicationId";
// import LoanApplicationStepper from "../../../components/LoanApplicationStepper";
// import ApplicationHeader from "../../../components/ApplicationHeader";
// import LoanApplicationFooter from "../../../components/LoanApplicationFooter";
// import "../../../assets/dist/ConsumerProject/Consumer/ConsumerApplicantCommon.css"
// import "./ConsumerDocumentsUpload.css";

// //const Application_Status_Id = localStorage.getItem("ApplicationStatusId") ? Number(localStorage.getItem("ApplicationStatusId")) : null;
// const Application_Status_Id = Number(localStorage.getItem("ApplicationStatusId"));

// console.log("Application_Status_Id", Application_Status_Id);


// const { Title, Text } = Typography;
// const { confirm } = Modal;

// const fileFormatText = (
//   <Text type="secondary" style={{ fontSize: 12 }}>
//     Format: pdf, xls, xlsx &nbsp;&nbsp; Size: upto 350k
//   </Text>
// );

// const fileFormatText1 = (
//   <Text type="secondary" style={{ fontSize: 12 }}>
//     Format: xls, xlsx &nbsp;&nbsp; Size: upto 350k
//   </Text>
// );

// const DocumentsUpload = () => {
//   const [form] = Form.useForm();
//   const applicationId = localStorage.getItem("ApplicationId");
//   const history = useHistory();
//   const [loading, setLoading] = useState(false);
//   const [uploading, setUploading] = useState(false);
//   const [applicantInfo, setApplicantInfo] = useState({});
//   const [applInfo, setApplInfo] = useState({});
//   const [fileUrls, setFileUrls] = useState({});
//   const [fileList, setFileList] = useState({});

//   const FIELD_LABELS = {
//     levconspfs: "levconspfs",
//     levconsfederaltax: "levconsfederaltax",
//     levconsk1s: "levconsk1s",
//     levconsfundstatement: "levconsfundstatement",//if available
//     levconscreditreport: "levconscreditreport",
//   };

//   // Personal Financial Statement (PFS) => UpDoc_Personal_FinStatement_Path
//   // First 2 Pages of Federal Tax Return => UpDoc3_FirstTwo_Pages_Tax_Return_Path
//   // K-1s (if available) => UpDoc2_Patriot_Act_Form_CoBorrower_Path_2
//   // Fund Statements or Private Stock Evidence (if available) => UpDoc1_Patriot_Act_Form_Applicant_Path
//   // Optional:Credit Report (PDF) => UpDoc_Credit_Breau_Report_Path

//   let APPLICATION_TYPE_ID = localStorage.getItem("applicationTypeId");
//   const location = useLocation();
//   let locData = location.state;
//   let applnObjId = "";
//   let activeKeyTab = null;
//   let fromDashboard = false;

//   if (locData && locData.applicationObjId) {
//     applnObjId = locData.applicationObjId;
//   }
//   if (locData && locData.isFromDashboard) {
//     fromDashboard = locData.isFromDashboard;
//   }
//   if (locData && locData.activeKey) {
//     activeKeyTab = locData.activeKey;
//   }

//   const [appObjId] = useState(applnObjId);
//   const [isFromDashboard] = useState(fromDashboard);
//   const [tabActiveKey] = useState(activeKeyTab);
//   const [fromNewAppPage] = useState(JSON.parse(localStorage.getItem("fromNewApplicationPage")));
//   const [isFromMyAppListPage] = useState(JSON.parse(localStorage.getItem("isFromMyApplicationsList")));

//   useEffect(() => {
//     if (!locData || (typeof locData === "object" && Object.keys(locData).length === 0)) {
//       history.push({ pathname: routes.consumerDashboard.path });
//       return;
//     }

//     getApplicantDetailsByID();
//   }, []);

//   useEffect(() => form.resetFields(), [applicantInfo]);

//   // const validateFile = (file) => {
//   //   const isValidType = [
//   //     "application/pdf",
//   //     "application/vnd.ms-excel",
//   //     "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
//   //   ].includes(file.type);

//   //   const isGt155KB = file.size >= 155 * 1024;
//   //   const isLt350KB = file.size <= 350 * 1024;

//   //   if (!isValidType) {
//   //     message.error("Only PDF/XLS/XLSX files are allowed!");
//   //     return false;
//   //   }
//   //   if (!isGt155KB || !isLt350KB) {
//   //     message.error("File size must be between 155KB and 350KB!");
//   //     return false;
//   //   }
//   //   return true;
//   // };

//   const validateFile = (file, allowedTypes) => {
//     const ext = file.name.split('.').pop().toLowerCase();

//     const typeMap = {
//       pdf: "application/pdf",
//       xls: "application/vnd.ms-excel",
//       xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
//     };

//     const validMimeTypes = allowedTypes.map(ext => typeMap[ext.replace(".", "")]);

//     if (!validMimeTypes.includes(file.type)) {
//       message.error(`Only ${allowedTypes.join(", ")} files are allowed!`);
//       return false;
//     }

//     const maxSize = 350 * 1024;
//     if (file.size > maxSize) {
//       message.error("File size must be below 350 KB!");
//       return false;
//     }

//     return true;
//   };


//   const handleUpload = (field, docType, label, allowedTypes) => async (file) => {
//     if (!validateFile(file, allowedTypes)) return Upload.LIST_IGNORE;

//     const formData = new FormData();
//     formData.append("files[]", file);
//     const ApplicationId = localStorage.getItem("ConsumerUserId");

//     setUploading(true);
//     try {
//       const res = await _consumerService.UploadPdfOrDocFile(formData, ApplicationId, docType);

//       if (res?.data?.IsSucess && res?.data?.URL) {
//         setUploading(false);
//         const relativePath = new URL(res.data.URL).pathname;
//         form.setFieldsValue({ [field]: relativePath });

//         setApplicantInfo((prev) => ({
//           ...prev,
//           [field]: relativePath,
//         }));

//         setFileUrls((prev) => ({
//           ...prev,
//           [field]: res.data.URL,
//         }));

//         setFileList((prev) => ({
//           ...prev,
//           [field]: [
//             {
//               uid: "-1",
//               name: label,
//               status: "done",
//               url: res.data.URL,
//               type: file.type,
//             },
//           ],
//         }));


//         // 🔥 THIS FIXES EMPTY PAYLOAD
//         form.setFieldsValue({
//           [field]: relativePath,
//         });

//         message.success(res?.data?.Message);
//       } else {
//         setUploading(false);
//         message.error(res?.data?.Message || `${file.name} failed to upload.`);
//       }
//     } catch (err) {
//       setUploading(false);
//       console.error("Upload error:", err);
//     }

//     return Upload.LIST_IGNORE;
//   };

//   const showDeleteConfirm = (field, label) => {
//     confirm({
//       title: `Are you sure you want to delete this ${label} file?`,
//       icon: <ExclamationCircleOutlined />,
//       okText: <span id="yesBtn">Yes</span>,
//       cancelText: <span id="noBtn">No</span>,
//       okType: "primary",
//       onOk() {
//         handleRemove(field);
//       },
//     });
//   };

//   const handleRemove = (field) => {
//     setFileUrls((prev) => {
//       const updated = { ...prev };
//       delete updated[field];
//       return updated;
//     });

//     setFileList((prev) => {
//       const updated = { ...prev };
//       delete updated[field];
//       return updated;
//     });

//     setApplicantInfo((prev) => {
//       const updated = { ...prev };
//       delete updated[field];
//       return updated;
//     });

//     form.setFieldsValue({ [field]: "" });
//   };

//   const getUploadItem = (label, field, docType, isRequired = true, showAltFormat = false, allowedTypes = [".pdf", ".xls", ".xlsx"]) => {
//     const uploadedUrl =
//       fileUrls[field] ||
//       (applicantInfo[field]
//         ? `${applicantInfo[field]}`
//         : undefined);

//     const currentFileList = fileList[field] || [];

//     return (
//       <>
//         <Form.Item
//           // label={`UPLOAD – ${label}`}
//           label={
//             <span className="inline-required-label">
//               {`UPLOAD – ${label}`}
//               {isRequired && <span className="required-star"> *</span>}
//             </span>
//           }
//           name={field}
//           rules={isRequired ? [{ required: true, message: `${label} is required` }] : []}
//           valuePropName="file"
//           getValueFromEvent={() => applicantInfo[field]}
//         >
//           <Upload
//             className="uploadDivDoc"
//             accept=".pdf,.xls,.xlsx"
//             beforeUpload={handleUpload(field, docType, label, allowedTypes)}
//             listType="picture"
//             maxCount={1}
//             fileList={currentFileList}
//             onRemove={() => showDeleteConfirm(field, label)}
//             customRequest={({ onSuccess }) => onSuccess("ok")}
//             onPreview={(file) => {
//               window.open(file.url, "_blank");
//             }}
//           >
//             {!uploadedUrl && (
//               <Button icon={<UploadOutlined />}>Select a file</Button>
//             )}
//           </Upload>
//         </Form.Item>
//         {showAltFormat ? fileFormatText1 : fileFormatText}
//       </>
//     );
//   };

//   const getPathname = (url) => {
//     try {
//       return new URL(url).pathname;
//     } catch {
//       if (typeof url === "string" && url.startsWith("/")) {
//         return url;
//       }
//       console.warn("Invalid URL passed to getPathname:", url);
//       return "";
//     }
//   };

//   const convertPTagsToBullets = (html) => {
//     if (!html) return html;

//     return `
//     <ul style="padding-left: 20px; margin: 0;">
//       ${html
//         .replace(/<p>/g, '<li>')
//         .replace(/<\/p>/g, '</li>')}
//     </ul>
//   `;
//   };

//   const onFinish = async (values) => {
//     const reqObj = {
//       Id: localStorage.getItem("ConsumerUserId"),
//       ScreenName: "personalfinancialstatement",
//       ApplicationId: localStorage.getItem("ApplicationIdText"),

//       Cons_PFS: getPathname(values.levconspfs),
//       Cons_FederalTax: getPathname(values.levconsfederaltax),
//       Cons_K1s: getPathname(values.levconsk1s),
//       Cons_FundStatement: getPathname(values.levconsfundstatement),
//       Cons_CreditReport: getPathname(values.levconscreditreport),

//       // CBRScore: values.creditBureauScore,
//       IsDocumentUploadCompleted: true,
//       IsIncomesourceCompleted: true,
//       IsExpensesCompleted: true,
//       IsBalancesheetAssetCompleted: true,
//       IsBalancesheetTotalAssetCompleted: true,
//       IsBalancesheetTotalLiabiltyCompleted: true,
//       // IsQuestionairCompleted: true,
//       // IsAllStepsCompleted: true,
//     };

//     // const reqObj = {
//     //   Id: localStorage.getItem("ConsumerUserId"),
//     //   ScreenName: "personalfinancialstatement",
//     //   ApplicationId: localStorage.getItem("ApplicationIdText"),

//     //   Cons_PFS: getPathname(applicantInfo.levconspfs),
//     //   Cons_FederalTax: getPathname(applicantInfo.levconsfederaltax),
//     //   Cons_K1s: getPathname(applicantInfo.levconsk1s),
//     //   Cons_FundStatement: getPathname(applicantInfo.levconsfundstatement),
//     //   Cons_CreditReport: getPathname(applicantInfo.levconscreditreport),

//     //   IsDocumentUploadCompleted: true,
//     //   IsIncomesourceCompleted: true,
//     //   IsExpensesCompleted: true,
//     //   IsBalancesheetAssetCompleted: true,
//     //   IsBalancesheetTotalAssetCompleted: true,
//     //   IsBalancesheetTotalLiabiltyCompleted: true,
//     // };


//     setLoading(true);
//     try {
//       const response = await _consumerService.submitConsumerData(reqObj);
//       if (response.data.IsSuccess) {
//         message.success(response.data.Message || "Upload Successful");

//         //history.push(routes.consumerDashboard.path);
//         if (localStorage.getItem("IsFromConsumerDashboard") == "true") {
//           history.push({ pathname: routes.consumerDetailsDashboard.path, state: { activeKey: "3" } });
//         } else if (localStorage.getItem("IsFromApplicationStatusTab") === "true") {
//           history.push({ pathname: routes.consumerDetailsDashboard.path, state: { activeKey: "1" } });
//         } else if (fromNewAppPage || isFromMyAppListPage) {
//           history.push({ pathname: routes.consumerUploadDocumentsPreview.path, state: { isFromDashboard: false } });
//         } else {
//           history.push(routes.consumerDetailsDashboard.path);
//         }
//       } else {
//         // message.error(response.data.Message || COMMON_ERROR_MSG);
//         if (response?.data?.Message) {
//           notification.error({
//             message: 'Error',
//             description: (
//               <div
//                 className="notification-content"
//                 dangerouslySetInnerHTML={{
//                   __html: convertPTagsToBullets(response?.data?.Message),
//                 }}
//               />
//             ),
//             duration: 0,
//             placement: 'top',
//             closable: true,
//             className: 'centered-notification',
//           });
//         } else {
//           message.error(COMMON_ERROR_MSG);
//         }
//       }

//       // if (isFromDashboard) {
//       //   // history.push({
//       //   //   pathname: routes.dashboard.path,
//       //   //   state: { appObjId, activeKey: tabActiveKey },
//       //   // });
//       // } else {
//       //   history.push();
//       // }
//     } catch (e) {
//       message.error("Something went wrong. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };


//   // const onBack = () => {
//   //   history.push(routes.newLiquidityApplication.path);
//   // };

//   const onBack = () => {
//     if (localStorage.getItem("IsFromApplicationStatusTab") === "true") {
//       history.push({ pathname: routes.consumerDetailsDashboard.path, state: { activeKey: "1" } });
//     } else if (localStorage.getItem("IsFromConsumerDashboard") == "true") {
//       history.push({ pathname: routes.consumerDetailsDashboard.path, state: { activeKey: "3" } });
//     } else if (fromNewAppPage || isFromMyAppListPage) {
//       history.push({ pathname: routes.newLiquidityApplication.path, state: { isFromBackUploadBtn: true } });
//     } else {
//       history.push(routes.consumerDetailsDashboard.path);
//     }
//   };

//   const getApplicantDetailsByID = async () => {
//     try {
//       setLoading(true);
//       const res = await _consumerService.getConsumerInformationByConsumerId(isFromDashboard ? appObjId : localStorage.getItem("ConsumerUserId"));

//       if (res.data) {
//         const resObj = res.data;
//         setApplInfo(resObj);

//         const infoObj = {
//           levconspfs: resObj.Cons_PFS,
//           levconsfederaltax: resObj.Cons_FederalTax,
//           levconsk1s: resObj.Cons_K1s,
//           levconsfundstatement: resObj.Cons_FundStatement,
//           levconscreditreport: resObj.Cons_CreditReport,
//           // creditBureauScore: resObj.CBRScore,
//         };

//         setApplicantInfo(infoObj);
//         form.setFieldsValue(infoObj);

//         const newFileList = {};
//         Object.keys(infoObj).forEach((field) => {
//           if (infoObj[field] && field !== "creditBureauScore") {
//             newFileList[field] = [
//               {
//                 uid: "-1",
//                 name: FIELD_LABELS[field] || field,
//                 status: "done",
//                 url: `${infoObj[field]}`,
//               },
//             ];
//           }
//         });
//         setFileList(newFileList);
//       }
//     } catch (e) {
//       console.error(e);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     // <Spin spinning={loading || uploading}>
//     //   <SidebarLayoutConsumer>
//     //     {/* {applicationId && applicationId !== 'undefined' && applicationId !== 'null' && (
//     //       <div style={{
//     //         position: "absolute",
//     //         top: 5,
//     //         right: 20,
//     //         margin: 0,
//     //         zIndex: 1000,
//     //         maxWidth: "1000px",
//     //         padding: "8px 16px",
//     //       }}>
//     //       </div>
//     //     )} */}
//     //     <Row className="rightbox upload_documentpage" style={{ minHeight: "100vh", minWidth: "85%", marginLeft:"10%"}}>
//     //       <Col span={24}>
//     //         <Title className="mt50" level={3} style={{ marginBottom: 30 }}>
//     //           Document Upload
//     //         </Title>
//     //         <Form
//     //           form={form}
//     //           layout="vertical"
//     //           onFinish={onFinish}
//     //           initialValues={applicantInfo}
//     //         >
//     //           <Row gutter={16}>
//     //             <div className='borderBox mt5 mb20' style={{display: "flex", flexFlow: "wrap", minWidth: "100%"}}>
//     //               <Col span={12} className="w50" style={{ marginTop: "10px" }}>
//     //                 <div className="f16 primaryColor">DOWNLOAD – Personal Financial Statement <FileExcelOutlined /> </div>
//     //                 <Button
//     //                   className="fbold"
//     //                   style={{ lineHeight: 0 }}
//     //                   type="link"
//     //                   icon={<DownloadOutlined />}
//     //                   href="ApplicantDataFields.xlsx"
//     //                   target="_blank"
//     //                 >
//     //                   Personal Financial Statement
//     //                 </Button>
//     //               </Col>
//     //               <Col span={12} className="w50 formBmargin">
//     //                 {getUploadItem(
//     //                   "Personal Financial Statement (PFS)",
//     //                   "levconspfs",
//     //                   "levconspfs"
//     //                 )}
//     //               </Col>
//     //             </div>
//     //             <Col span={12} className="w50 formBmargin" style={{ marginTop: "20px" }}>
//     //               {getUploadItem(
//     //                 "First 2 Pages of Federal Tax Return",
//     //                 "levconsfederaltax",
//     //                 "levconsfederaltax"
//     //               )}
//     //             </Col>

//     //             <Col span={12} className="w50 formBmargin" style={{ marginTop: "20px" }}>
//     //               {getUploadItem(
//     //                 "K-1s",
//     //                 "levconsk1s",
//     //                 "levconsk1s",
//     //                 false
//     //               )}
//     //             </Col>

//     //             <Col span={12} className="w50 formBmargin mt50">
//     //               {getUploadItem(
//     //                 "Fund Statements/Private Stock Evidence",
//     //                 "levconsfundstatement",
//     //                 "levconsfundstatement",
//     //                 false
//     //               )}
//     //             </Col>

//     //             <Col span={12} className="w50 formBmargin mt50">
//     //               {getUploadItem(
//     //                 "Credit Report (PDF)",
//     //                 "levconscreditreport",
//     //                 "levconscreditreport",
//     //                 false
//     //               )}
//     //             </Col>
//     //           </Row>

//     //           <Form.Item
//     //             style={{ marginTop: "25px" }}
//     //             label="CBR Score"
//     //             name="creditBureauScore"
//     //             rules={[
//     //               { required: true, message: "CBR Score is required" },
//     //               {
//     //                 validator: (_, value) => {
//     //                   const num = Number(value);
//     //                   if (!Number.isInteger(num)) {
//     //                     return Promise.reject(new Error("Enter a valid integer"));
//     //                   }
//     //                   if (num < 0 || num > 850) {
//     //                     return Promise.reject(new Error("CBR Score must be between 0 and 850"));
//     //                   }
//     //                   return Promise.resolve();
//     //                 },
//     //               },
//     //             ]}
//     //           >
//     //             <IntegerInput
//     //               className="w300"
//     //               maxLength={3}
//     //               placeholder="Enter CBR Score"
//     //             />
//     //           </Form.Item>

//     //           <Form.Item className="w95">
//     //             <div
//     //               style={{
//     //                 display: "flex",
//     //                 gap: 16,
//     //                 marginTop: 10,
//     //               }}
//     //             >
//     //               <Button
//     //                 onClick={onBack}
//     //                 icon={<LeftOutlined />}
//     //               >
//     //                 Go Back
//     //               </Button>
//     //               <Button
//     //                 type="primary"
//     //                 htmlType="submit"
//     //                 disabled={![1, 6].includes(Number(localStorage.getItem("ApplicationStatusId")))}
//     //               >
//     //                 Save And Proceed <RightOutlined />
//     //               </Button>
//     //             </div>
//     //           </Form.Item>
//     //         </Form>
//     //       </Col>
//     //     </Row>
//     //   </SidebarLayoutConsumer>
//     // </Spin>

//     <Spin spinning={loading || uploading}>
//       <SidebarLayoutConsumer>
//         <div className="loan-application-container">
//           {/* Responsive Stepper */}
//           <LoanApplicationStepper currentStep={1} showApplicationId={true} />

//           {/* Card */}
//           <Card
//             className="loan-application-card cardViewMain"
//             bodyStyle={{
//               display: "flex",
//               flexDirection: "column",
//               flex: 1,
//               overflow: "hidden"
//             }}
//           >
//             <Form
//               form={form}
//               layout="vertical"
//               onFinish={onFinish}
//               requiredMark={false}
//               initialValues={applicantInfo}
//               className="loan-application-form"
//             >

//               {/* 🔥 HIDDEN FORM FIELDS – REQUIRED FOR SUBMIT */}
//               <Form.Item name="levconspfs" hidden />
//               <Form.Item name="levconsfederaltax" hidden />
//               <Form.Item name="levconsk1s" hidden />
//               <Form.Item name="levconsfundstatement" hidden />
//               <Form.Item name="levconscreditreport" hidden />


//               {/* Scrollable Form Content */}
//               <div className="loan-application-scrollable-content loan-application-scrollbar">
//                 {/* Personal Financial Statement Section */}
//                 <div className="pfs-section-card">
//                   <Row justify="space-between" align="middle" style={{ marginBottom: 20 }}>
//                     <Col xs={24} sm={12}>
//                       <Title level={4} style={{ margin: 0 }}>
//                         Personal Financial Statement
//                       </Title>
//                     </Col>

//                     <Col xs={24} sm={12} style={{ textAlign: 'right' }}>
//                       <Button
//                         type="primary"
//                         ghost
//                         icon={<FileExcelOutlined />}
//                         onClick={() => window.open("PersonalFinancialStatement.xlsx", "_blank")}
//                       >
//                         Download PFS template
//                       </Button>
//                     </Col>
//                   </Row>

//                   {/* <Row gutter={[24, 24]}>
//                     <DocumentUploadCard
//                       title="Personal Financial Statement (PFS)"
//                       required
//                       formats="XLS, XLSX"
//                       maxSize="350 KB"
//                       icon={<FileExcelOutlined />}
//                       fullWidth
//                       fileList={fileList['levconspfs'] || []}
//                       uploadedUrl={fileUrls['levconspfs'] || (applicantInfo['levconspfs'] ? `${applicantInfo['levconspfs']}` : undefined)}
//                       uploadProps={{
//                         accept: ".xls,.xlsx",
//                         beforeUpload: handleUpload('levconspfs', 'levconspfs', 'Personal Financial Statement (PFS)', [".xls", ".xlsx"]),
//                         listType: "picture",
//                         maxCount: 1,
//                         onRemove: () => showDeleteConfirm('levconspfs', 'Personal Financial Statement (PFS)'),
//                         customRequest: ({ onSuccess }) => onSuccess("ok"),
//                         onPreview: (file) => window.open(file.url, "_blank"),
//                       }}
//                     />
//                   </Row> */}

//                   <Form.Item
//                     name="levconspfs"
//                     rules={[{ required: true, message: "Personal Financial Statement (PFS) is required" }]}
//                   >
//                     <DocumentUploadCard

//                       title={
//                         <>
//                           Personal Financial Statement (PFS)
//                           <span style={{ color: "red" }}> *</span>
//                         </>
//                       }

//                       formats="XLS, XLSX"
//                       maxSize="350 KB"
//                       icon={<FileExcelOutlined />}
//                       fullWidth
//                       fileList={fileList['levconspfs'] || []}
//                       uploadedUrl={
//                         fileUrls['levconspfs'] ||
//                         (applicantInfo['levconspfs'] ? applicantInfo['levconspfs'] : undefined)
//                       }
//                       uploadProps={{
//                         accept: ".xls,.xlsx",
//                         beforeUpload: handleUpload(
//                           'levconspfs',
//                           'levconspfs',
//                           'Personal Financial Statement (PFS)',
//                           [".xls", ".xlsx"]
//                         ),
//                         listType: "picture",
//                         maxCount: 1,
//                         onRemove: () =>
//                           showDeleteConfirm('levconspfs', 'Personal Financial Statement (PFS)'),
//                         customRequest: ({ onSuccess }) => onSuccess("ok"),
//                         onPreview: (file) => window.open(file.url, "_blank"),
//                       }}
//                     />
//                   </Form.Item>
//                 </div>



//                 {/* Other Financial Details Section */}
//                 <div className="financial-details-card">
//                   <Title level={4} className="financial-details-title">
//                     Other Financial Details
//                   </Title>

//                   <Row gutter={[24, 24]} align="stretch">
//                     <Col xs={24} md={12} style={{ display: "flex" }}>
//                       <Form.Item
//                         name="levconsfederaltax"
//                         rules={[{ required: true, message: "First 2 Pages of Federal Tax Return is required" }]}
//                         style={{ flex: 1, marginBottom: 0 }}
//                       >
//                         <DocumentUploadCard

//                           title={
//                             <>
//                               First 2 Pages of Federal Tax Return
//                               <span style={{ color: "red" }}> *</span>
//                             </>
//                           }

//                           formats="PDF, XLS, XLSX"
//                           maxSize="350 KB"
//                           icon={<FilePdfOutlined />}
//                           fullWidth
//                           fileList={fileList["levconsfederaltax"] || []}
//                           uploadedUrl={fileUrls["levconsfederaltax"] || applicantInfo?.levconsfederaltax}
//                           uploadProps={{
//                             accept: ".pdf,.xls,.xlsx",
//                             beforeUpload: handleUpload(
//                               "levconsfederaltax",
//                               "levconsfederaltax",
//                               "First 2 Pages of Federal Tax Return",
//                               [".pdf", ".xls", ".xlsx"]
//                             ),
//                             listType: "picture",
//                             maxCount: 1,
//                             onRemove: () =>
//                               showDeleteConfirm(
//                                 "levconsfederaltax",
//                                 "First 2 Pages of Federal Tax Return"
//                               ),
//                             customRequest: ({ onSuccess }) => onSuccess("ok"),
//                             onPreview: (file) => window.open(file.url, "_blank"),
//                           }}
//                         />
//                       </Form.Item>
//                     </Col>

//                     <Col xs={24} md={12} style={{ display: "flex" }}>
//                       <Form.Item
//                         name="levconsk1s"
//                         style={{ flex: 1, marginBottom: 0 }}
//                       >
//                         <DocumentUploadCard
//                           title="K-1s"
//                           formats="PDF, XLS, XLSX"
//                           maxSize="350 KB"
//                           icon={<FilePdfOutlined />}
//                           fullWidth
//                           fileList={fileList["levconsk1s"] || []}
//                           uploadedUrl={fileUrls["levconsk1s"] || applicantInfo?.levconsk1s}
//                           uploadProps={{
//                             accept: ".pdf,.xls,.xlsx",
//                             beforeUpload: handleUpload(
//                               "levconsk1s",
//                               "levconsk1s",
//                               "K-1s",
//                               [".pdf", ".xls", ".xlsx"]
//                             ),
//                             listType: "picture",
//                             maxCount: 1,
//                             onRemove: () => showDeleteConfirm("levconsk1s", "K-1s"),
//                             customRequest: ({ onSuccess }) => onSuccess("ok"),
//                             onPreview: (file) => window.open(file.url, "_blank"),
//                           }}
//                         />
//                       </Form.Item>
//                     </Col>

//                     <Col xs={24} md={12} style={{ display: "flex" }}>
//                       <Form.Item name="levconscreditreport" style={{ flex: 1, marginBottom: 0 }}>
//                         <DocumentUploadCard
//                           title="Credit Report"
//                           formats="PDF, XLS, XLSX"
//                           maxSize="350 KB"
//                           icon={<FilePdfOutlined />}
//                           fullWidth
//                           fileList={fileList["levconscreditreport"] || []}
//                           uploadedUrl={fileUrls["levconscreditreport"] || applicantInfo?.levconscreditreport}
//                           uploadProps={{
//                             accept: ".pdf,.xls,.xlsx",
//                             beforeUpload: handleUpload(
//                               "levconscreditreport",
//                               "levconscreditreport",
//                               "Credit Report",
//                               [".pdf", ".xls", ".xlsx"]
//                             ),
//                             listType: "picture",
//                             maxCount: 1,
//                             onRemove: () =>
//                               showDeleteConfirm("levconscreditreport", "Credit Report"),
//                             customRequest: ({ onSuccess }) => onSuccess("ok"),
//                             onPreview: (file) => window.open(file.url, "_blank"),
//                           }}
//                         />
//                       </Form.Item>
//                     </Col>

//                     <Col xs={24} md={12} style={{ display: "flex" }}>
//                       <Form.Item name="levconsfundstatement" style={{ flex: 1, marginBottom: 0 }}>
//                         <DocumentUploadCard
//                           title="Fund Statements / Private Stock Evidence"
//                           formats="PDF, XLS, XLSX"
//                           maxSize="350 KB"
//                           icon={<FilePdfOutlined />}
//                           fullWidth
//                           fileList={fileList["levconsfundstatement"] || []}
//                           uploadedUrl={fileUrls["levconsfundstatement"] || applicantInfo?.levconsfundstatement}
//                           uploadProps={{
//                             accept: ".pdf,.xls,.xlsx",
//                             beforeUpload: handleUpload(
//                               "levconsfundstatement",
//                               "levconsfundstatement",
//                               "Fund Statements / Private Stock Evidence",
//                               [".pdf", ".xls", ".xlsx"]
//                             ),
//                             listType: "picture",
//                             maxCount: 1,
//                             onRemove: () =>
//                               showDeleteConfirm(
//                                 "levconsfundstatement",
//                                 "Fund Statements / Private Stock Evidence"
//                               ),
//                             customRequest: ({ onSuccess }) => onSuccess("ok"),
//                             onPreview: (file) => window.open(file.url, "_blank"),
//                           }}
//                         />
//                       </Form.Item>
//                     </Col>
//                   </Row>



//                   {/* <Row gutter={[24, 24]}>

//                     <DocumentUploadCard
//                       title="First 2 Pages of Federal Tax Return"
//                       required
//                       formats="PDF, XLS, XLSX"
//                       maxSize="350 KB"
//                       icon={<FilePdfOutlined />}
//                       fileList={fileList['levconsfederaltax'] || []}
//                       uploadedUrl={fileUrls['levconsfederaltax'] || (applicantInfo['levconsfederaltax'] ? `${applicantInfo['levconsfederaltax']}` : undefined)}
//                       uploadProps={{
//                         accept: ".pdf,.xls,.xlsx",
//                         beforeUpload: handleUpload('levconsfederaltax', 'levconsfederaltax', 'First 2 Pages of Federal Tax Return', [".pdf", ".xls", ".xlsx"]),
//                         listType: "picture",
//                         maxCount: 1,
//                         onRemove: () => showDeleteConfirm('levconsfederaltax', 'First 2 Pages of Federal Tax Return'),
//                         customRequest: ({ onSuccess }) => onSuccess("ok"),
//                         onPreview: (file) => window.open(file.url, "_blank"),
//                       }}
//                     />

//                     <DocumentUploadCard
//                       title="K-1s"
//                       formats="PDF, XLS, XLSX"
//                       maxSize="350 KB"
//                       icon={<FilePdfOutlined />}
//                       fileList={fileList['levconsk1s'] || []}
//                       uploadedUrl={fileUrls['levconsk1s'] || (applicantInfo['levconsk1s'] ? `${applicantInfo['levconsk1s']}` : undefined)}
//                       uploadProps={{
//                         accept: ".pdf,.xls,.xlsx",
//                         beforeUpload: handleUpload('levconsk1s', 'levconsk1s', 'K-1s', [".pdf", ".xls", ".xlsx"]),
//                         listType: "picture",
//                         maxCount: 1,
//                         onRemove: () => showDeleteConfirm('levconsk1s', 'K-1s'),
//                         customRequest: ({ onSuccess }) => onSuccess("ok"),
//                         onPreview: (file) => window.open(file.url, "_blank"),
//                       }}
//                     />

//                     <DocumentUploadCard
//                       title="Credit Report"
//                       formats="PDF, XLS, XLSX"
//                       maxSize="350 KB"
//                       icon={<FilePdfOutlined />}
//                       fileList={fileList['levconscreditreport'] || []}
//                       uploadedUrl={fileUrls['levconscreditreport'] || (applicantInfo['levconscreditreport'] ? `${applicantInfo['levconscreditreport']}` : undefined)}
//                       uploadProps={{
//                         accept: ".pdf,.xls,.xlsx",
//                         beforeUpload: handleUpload('levconscreditreport', 'levconscreditreport', 'Credit Report (PDF)', [".pdf", ".xls", ".xlsx"]),
//                         listType: "picture",
//                         maxCount: 1,
//                         onRemove: () => showDeleteConfirm('levconscreditreport', 'Credit Report (PDF)'),
//                         customRequest: ({ onSuccess }) => onSuccess("ok"),
//                         onPreview: (file) => window.open(file.url, "_blank"),
//                       }}
//                     />

//                     <DocumentUploadCard
//                       title="Fund Statements / Private Stock Evidence"
//                       formats="PDF, XLS, XLSX"
//                       maxSize="350 KB"
//                       icon={<FilePdfOutlined />}
//                       fileList={fileList['levconsfundstatement'] || []}
//                       uploadedUrl={fileUrls['levconsfundstatement'] || (applicantInfo['levconsfundstatement'] ? `${applicantInfo['levconsfundstatement']}` : undefined)}
//                       uploadProps={{
//                         accept: ".pdf,.xls,.xlsx",
//                         beforeUpload: handleUpload('levconsfundstatement', 'levconsfundstatement', 'Fund Statements/Private Stock Evidence', [".pdf", ".xls", ".xlsx"]),
//                         listType: "picture",
//                         maxCount: 1,
//                         onRemove: () => showDeleteConfirm('levconsfundstatement', 'Fund Statements/Private Stock Evidence'),
//                         customRequest: ({ onSuccess }) => onSuccess("ok"),
//                         onPreview: (file) => window.open(file.url, "_blank"),
//                       }}
//                     />
//                   </Row> */}
//                 </div>
//               </div>

//               {/* <Form.Item>
//                 <div style={{ display: "flex", gap: 16, marginTop: 20, width: "80%" }}>
//                   <Button onClick={onBack} icon={<LeftOutlined />}>
//                     Go Back
//                   </Button>

//                   <Button
//                     type="primary"
//                     htmlType="submit"
//                     disabled={
//                       ![1, 6].includes(Number(localStorage.getItem("ApplicationStatusId")))
//                     }
//                   >
//                     Save And Proceed <RightOutlined />
//                   </Button>
//                 </div>
//               </Form.Item> */}

//               <LoanApplicationFooter
//                 onBack={onBack}
//                 submitDisabled={fromNewAppPage ? false : ![1, 6].includes(Number(localStorage.getItem("ApplicationStatusId")))}
//               />
//             </Form>
//           </Card>
//         </div>
//       </SidebarLayoutConsumer>
//     </Spin>

//   );
// };

// export default DocumentsUpload;


import React, { useState, useEffect, useRef } from "react";
import { Form, Input, Upload, Button, message, Typography, Row, Col, Spin, Tooltip, Modal, InputNumber, Card, Divider, notification, Radio } from "antd";
import { UploadOutlined, DownloadOutlined, CheckCircleOutlined, CloseOutlined, FileExcelOutlined, ExclamationCircleOutlined, LeftOutlined, RightOutlined, FilePdfOutlined } from "@ant-design/icons";
import LeftLayout from "../../pageHeader/LeftLayout";
import SidebarLayoutConsumer from "../Administrator/SidebarLayoutConsumer";
import _consumerService from "../../../modules/consumerService";
import { useHistory, useLocation } from "react-router-dom";
import { API_HOST, COMMON_ERROR_MSG } from "../../../constants/constants";
import { routes } from "../../../routes/Routes";
import IntegerInput from "../../../components/IntergerInput";
import DocumentUploadCard from "../../../components/DocumentUploadCard";
import PdfDocumentUploadCard from "../../../components/PdfDocumentUploadCard";
//import IntegerInput from "../../components/IntergerInput";
import ConsumerApplicationProgressBar from "../Consumer/ConsumerApplicationProgressBar";
import ConsumerShowApplicationId from "../Consumer/ConsumerShowApplicationId";
import LoanApplicationStepper from "../../../components/LoanApplicationStepper";
import ApplicationHeader from "../../../components/ApplicationHeader";
import LoanApplicationFooter from "../../../components/LoanApplicationFooter";
import "../../../assets/dist/ConsumerProject/Consumer/ConsumerApplicantCommon.css"
import "./ConsumerDocumentsUpload.css";


//const Application_Status_Id = localStorage.getItem("ApplicationStatusId") ? Number(localStorage.getItem("ApplicationStatusId")) : null;
const Application_Status_Id = Number(localStorage.getItem("ApplicationStatusId"));

console.log("Application_Status_Id", Application_Status_Id);


const { Title, Text } = Typography;
const { confirm } = Modal;

const fileFormatText = (
  <Text type="secondary" style={{ fontSize: 12 }}>
    Format: pdf, xls, xlsx &nbsp;&nbsp; Size: upto 4000k
  </Text>
);

const fileFormatText1 = (
  <Text type="secondary" style={{ fontSize: 12 }}>
    Format: xls, xlsx &nbsp;&nbsp; Size: upto 4000k
  </Text>
);

const DocumentsUpload = () => {
  const [form] = Form.useForm();
  const applicationId = localStorage.getItem("ApplicationId");
  const ApplicationObjId = localStorage.getItem("ApplicationObjId");
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [applicantInfo, setApplicantInfo] = useState({});
  const [applInfo, setApplInfo] = useState({});
  const [fileUrls, setFileUrls] = useState({});
  const [fileList, setFileList] = useState({});
  const [pfsMethod, setPfsMethod] = useState(null);
  const [apiPfsMethod, setApiPfsMethod] = useState(null);
  const [thirdpartyProvider, setThirdPartyProvider] = useState(null);
const [preUploadedPfsUrl, setPreUploadedPfsUrl] = useState(`${API_HOST}/TempImages/BlankPFS/AppBlankPFS.pdf`);

  const FIELD_LABELS = {
    levconspfs: "levconspfs",
    levconsfederaltax: "levconsfederaltax",
    levconsk1s: "levconsk1s",
    levconsfundstatement: "levconsfundstatement",//if available
    levconscreditreport: "levconscreditreport",
  };

  // Personal Financial Statement (PFS) => UpDoc_Personal_FinStatement_Path
  // First 2 Pages of Federal Tax Return => UpDoc3_FirstTwo_Pages_Tax_Return_Path
  // K-1s (if available) => UpDoc2_Patriot_Act_Form_CoBorrower_Path_2
  // Fund Statements or Private Stock Evidence (if available) => UpDoc1_Patriot_Act_Form_Applicant_Path
  // Optional:Credit Report (PDF) => UpDoc_Credit_Breau_Report_Path

  let APPLICATION_TYPE_ID = localStorage.getItem("applicationTypeId");
  const location = useLocation();
  let locData = location.state;
  let applnObjId = "";
  let activeKeyTab = null;
  let fromDashboard = false;

  if (locData && locData.applicationObjId) {
    applnObjId = locData.applicationObjId;
  }
  if (locData && locData.isFromDashboard) {
    fromDashboard = locData.isFromDashboard;
  }
  if (locData && locData.activeKey) {
    activeKeyTab = locData.activeKey;
  }

  const [appObjId] = useState(applnObjId);
  const [isFromDashboard] = useState(fromDashboard);
  const [tabActiveKey] = useState(activeKeyTab);
  const [fromNewAppPage] = useState(JSON.parse(localStorage.getItem("fromNewApplicationPage")));
  const [isFromMyAppListPage] = useState(JSON.parse(localStorage.getItem("isFromMyApplicationsList")));

  useEffect(() => {
    if (!locData || (typeof locData === "object" && Object.keys(locData).length === 0)) {
      history.push({ pathname: routes.consumerDashboard.path });
      return;
    }

    getApplicantDetailsByID();
  }, []);

  useEffect(() => form.resetFields(), [applicantInfo]);

  // const validateFile = (file) => {
  //   const isValidType = [
  //     "application/pdf",
  //     "application/vnd.ms-excel",
  //     "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  //   ].includes(file.type);

  //   const isGt155KB = file.size >= 155 * 1024;
  //   const isLt350KB = file.size <= 350 * 1024;

  //   if (!isValidType) {
  //     message.error("Only PDF/XLS/XLSX files are allowed!");
  //     return false;
  //   }
  //   if (!isGt155KB || !isLt350KB) {
  //     message.error("File size must be between 155KB and 350KB!");
  //     return false;
  //   }
  //   return true;
  // };

  const validateFile = (file, allowedTypes) => {
    const ext = file.name.split('.').pop().toLowerCase();

    const typeMap = {
      pdf: "application/pdf",
      xls: "application/vnd.ms-excel",
      xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    };

    const validMimeTypes = allowedTypes.map(ext => typeMap[ext.replace(".", "")]);

    if (!validMimeTypes.includes(file.type)) {
      message.error(`Only ${allowedTypes.join(", ")} files are allowed!`);
      return false;
    }

    // const maxSize = 350 * 1024;
    // if (file.size > maxSize) {
    //   message.error("File size must be below 350 KB!");
    //   return false;
    // }

    return true;
  };


  const handleUpload = (field, docType, label, allowedTypes) => async (file) => {
    if (!validateFile(file, allowedTypes)) return Upload.LIST_IGNORE;

    const formData = new FormData();
    formData.append("files[]", file);
    const ApplicationId = localStorage.getItem("ConsumerUserId");

    setUploading(true);
    try {
      const res = await _consumerService.UploadPdfOrDocFile(formData, ApplicationId, docType);

      if (res?.data?.IsSucess && res?.data?.URL) {
        setUploading(false);
        const relativePath = new URL(res.data.URL).pathname;
        form.setFieldsValue({ [field]: relativePath });

        setApplicantInfo((prev) => ({
          ...prev,
          [field]: relativePath,
        }));

        setFileUrls((prev) => ({
          ...prev,
          [field]: res.data.URL,
        }));

        setFileList((prev) => ({
          ...prev,
          [field]: [
            {
              uid: "-1",
              name: label,
              status: "done",
              url: res.data.URL,
              type: file.type,
            },
          ],
        }));


        // 🔥 THIS FIXES EMPTY PAYLOAD
        form.setFieldsValue({
          [field]: relativePath,
        });

        message.success(res?.data?.Message);
      } else {
        setUploading(false);
        message.error(res?.data?.Message || `${file.name} failed to upload.`);
      }
    } catch (err) {
      setUploading(false);
      console.error("Upload error:", err);
    }

    return Upload.LIST_IGNORE;
  };

  const showDeleteConfirm = (field, label) => {
    confirm({
      title: `Are you sure you want to delete this ${label} file?`,
      icon: <ExclamationCircleOutlined />,
      okText: <span id="yesBtn">Yes</span>,
      cancelText: <span id="noBtn">No</span>,
      okType: "primary",
      onOk() {
        handleRemove(field);
      },
    });
  };

  const handleRemove = (field) => {
    setFileUrls((prev) => {
      const updated = { ...prev };
      delete updated[field];
      return updated;
    });

    setFileList((prev) => {
      const updated = { ...prev };
      delete updated[field];
      return updated;
    });

    setApplicantInfo((prev) => {
      const updated = { ...prev };
      delete updated[field];
      return updated;
    });

    form.setFieldsValue({ [field]: "" });
  };

  const getUploadItem = (label, field, docType, isRequired = true, showAltFormat = false, allowedTypes = [".pdf", ".xls", ".xlsx"]) => {
    const uploadedUrl =
      fileUrls[field] ||
      (applicantInfo[field]
        ? `${applicantInfo[field]}`
        : undefined);

    const currentFileList = fileList[field] || [];

    return (
      <>
        <Form.Item
          // label={`UPLOAD – ${label}`}
          label={
            <span className="inline-required-label">
              {`UPLOAD – ${label}`}
              {isRequired && <span className="required-star"> *</span>}
            </span>
          }
          name={field}
          rules={isRequired ? [{ required: true, message: `${label} is required` }] : []}
          valuePropName="file"
          getValueFromEvent={() => applicantInfo[field]}
        >
          <Upload
            className="uploadDivDoc"
            accept=".pdf,.xls,.xlsx"
            beforeUpload={handleUpload(field, docType, label, allowedTypes)}
            listType="picture"
            maxCount={1}
            fileList={currentFileList}
            onRemove={() => showDeleteConfirm(field, label)}
            customRequest={({ onSuccess }) => onSuccess("ok")}
            onPreview={(file) => {
              window.open(file.url, "_blank");
            }}
          >
            {!uploadedUrl && (
              <Button icon={<UploadOutlined />}>Select a file</Button>
            )}
          </Upload>
        </Form.Item>
        {showAltFormat ? fileFormatText1 : fileFormatText}
      </>
    );
  };

  const getPathname = (url) => {
    try {
      return new URL(url).pathname;
    } catch {
      if (typeof url === "string" && url.startsWith("/")) {
        return url;
      }
      console.warn("Invalid URL passed to getPathname:", url);
      return "";
    }
  };

  const convertPTagsToBullets = (html) => {
    if (!html) return html;

    return `
    <ul style="padding-left: 20px; margin: 0;">
      ${html
        .replace(/<p>/g, '<li>')
        .replace(/<\/p>/g, '</li>')}
    </ul>
  `;
  };

  const onFinish = async (values) => {
    let selectedApplicationFlow;
    if(pfsMethod =="pdfupload") {
      selectedApplicationFlow ="Upload";
    } else if(pfsMethod =="manualentry") {
      selectedApplicationFlow ="Manually";
    } else if(pfsMethod =="thirdparty") {
      selectedApplicationFlow ="3rdParty";
    }
    const reqObj = {
      Id: localStorage.getItem("ConsumerUserId"),
      ScreenName: "personalfinancialstatement",
      ApplicationId: localStorage.getItem("ApplicationIdText"),

      Cons_PFS: getPathname(values.levconspfs),
      Cons_FederalTax: getPathname(values.levconsfederaltax),
      Cons_K1s: getPathname(values.levconsk1s),
      Cons_FundStatement: getPathname(values.levconsfundstatement),
      Cons_CreditReport: getPathname(values.levconscreditreport),
      IsDocumentUploadCompleted: true,
      IsIncomesourceCompleted: true,
      IsExpensesCompleted: true,
      IsBalancesheetAssetCompleted: true,
      IsBalancesheetTotalAssetCompleted: true,
      IsBalancesheetTotalLiabiltyCompleted: true,
      ApplicationFlowType:selectedApplicationFlow,
      // IsQuestionairCompleted: true,
      // IsAllStepsCompleted: true,
    };
//  if (pfsMethod == "manualentry") {
//     reqObj.CBRScore = values.creditBureauScore;
//   }
    // const reqObj = {
    //   Id: localStorage.getItem("ConsumerUserId"),
    //   ScreenName: "personalfinancialstatement",
    //   ApplicationId: localStorage.getItem("ApplicationIdText"),

    //   Cons_PFS: getPathname(applicantInfo.levconspfs),
    //   Cons_FederalTax: getPathname(applicantInfo.levconsfederaltax),
    //   Cons_K1s: getPathname(applicantInfo.levconsk1s),
    //   Cons_FundStatement: getPathname(applicantInfo.levconsfundstatement),
    //   Cons_CreditReport: getPathname(applicantInfo.levconscreditreport),

    //   IsDocumentUploadCompleted: true,
    //   IsIncomesourceCompleted: true,
    //   IsExpensesCompleted: true,
    //   IsBalancesheetAssetCompleted: true,
    //   IsBalancesheetTotalAssetCompleted: true,
    //   IsBalancesheetTotalLiabiltyCompleted: true,
    // };


    setLoading(true);
    try {
      const response = await _consumerService.submitConsumerData(reqObj);
      if (response.data.IsSuccess) {
        message.success(response.data.Message || "Upload Successful");

        //history.push(routes.consumerDashboard.path);
        if(pfsMethod =="manualentry" || pfsMethod =="pdfupload") {
          localStorage.setItem("selectedDocumentOption", pfsMethod);
           history.push({ pathname: routes.consumerUploadDocumentsPreview.path, state: { selectedDocumentOption: pfsMethod, applicationObjId:localStorage.getItem("ConsumerUserId") } });
        } else {
             if (localStorage.getItem("IsFromConsumerDashboard") == "true") {
          history.push({ pathname: routes.consumerDetailsDashboard.path, state: { activeKey: "3" } });
        } else if (localStorage.getItem("IsFromApplicationStatusTab") === "true") {
          history.push({ pathname: routes.consumerDetailsDashboard.path, state: { activeKey: "1" } });
        } else if (fromNewAppPage || isFromMyAppListPage) {
          history.push({ pathname: routes.consumerUploadDocumentsPreview.path, state: { isFromDashboard: false } });
        } else {
          history.push(routes.consumerDetailsDashboard.path);
        }
        }

       
      } else {
        // message.error(response.data.Message || COMMON_ERROR_MSG);
        if (response?.data?.Message) {
          notification.error({
            message: 'Error',
            description: (
              <div
                className="notification-content"
                dangerouslySetInnerHTML={{
                  __html: convertPTagsToBullets(response?.data?.Message),
                }}
              />
            ),
            duration: 0,
            placement: 'top',
            closable: true,
            className: 'centered-notification',
          });
        } else {
          message.error(COMMON_ERROR_MSG);
        }
      }

      // if (isFromDashboard) {
      //   // history.push({
      //   //   pathname: routes.dashboard.path,
      //   //   state: { appObjId, activeKey: tabActiveKey },
      //   // });
      // } else {
      //   history.push();
      // }
    } catch (e) {
      message.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };


  // const onBack = () => {
  //   history.push(routes.newLiquidityApplication.path);
  // };

  const onBack = () => {
    if (localStorage.getItem("IsFromApplicationStatusTab") === "true") {
      history.push({ pathname: routes.consumerDetailsDashboard.path, state: { activeKey: "1" } });
    } else if (localStorage.getItem("IsFromConsumerDashboard") == "true") {
      history.push({ pathname: routes.consumerDetailsDashboard.path, state: { activeKey: "3" } });
    } else if (fromNewAppPage || isFromMyAppListPage) {
      history.push({ pathname: routes.newLiquidityApplication.path, state: { isFromBackUploadBtn: true } });
    } else {
      history.push(routes.consumerDetailsDashboard.path);
    }
  };
const mapApplicationFlowTypeToPfsMethod = (value) => {
  if (!value) return null;

  const map = {
    upload: "pdfupload",
    manually: "manualentry",
    "3rdparty": "thirdparty",
  };

  return map[value.toLowerCase()] || null;
};


  const getApplicantDetailsByID = async () => {
    try {
      setLoading(true);
      const res = await _consumerService.getConsumerInformationByConsumerId(isFromDashboard ? appObjId : localStorage.getItem("ConsumerUserId"));

      if (res.data) {
        const resObj = res.data;
        setApplInfo(resObj);
            setPfsMethod(
  mapApplicationFlowTypeToPfsMethod(resObj.ApplicationFlowType)
);  
  setApiPfsMethod(mapApplicationFlowTypeToPfsMethod(resObj.ApplicationFlowType))
        const infoObj = {
          levconspfs: resObj.Cons_PFS,
          levconsfederaltax: resObj.Cons_FederalTax,
          levconsk1s: resObj.Cons_K1s,
          levconsfundstatement: resObj.Cons_FundStatement,
          levconscreditreport: resObj.Cons_CreditReport,
           //creditBureauScore: resObj.CBRScore,
        };

        setApplicantInfo(infoObj);
        form.setFieldsValue(infoObj);

        const newFileList = {};
        Object.keys(infoObj).forEach((field) => {
          if (infoObj[field] && field !== "creditBureauScore") {
            newFileList[field] = [
              {
                uid: "-1",
                name: FIELD_LABELS[field] || field,
                status: "done",
                url: `${infoObj[field]}`,
              },
            ];
          }
        });
        setFileList(newFileList);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const previouslyUploadedDocs = [
    {
      key: "pfs_2024",
      name: "Personal_Financial_Statement_2024.xlsx",
      size: "248.5 KB",
      uploadedOn: "Jan 7, 2026",
      url: "https://example.com/Personal_Financial_Statement_2024.xlsx",
    },
    {
      key: "pfs_dec_2024",
      name: "PFS_Statement_Dec_2024.xlsx",
      size: "312.8 KB",
      uploadedOn: "Jan 5, 2026",
      url: "https://example.com/PFS_Statement_Dec_2024.xlsx",
    },
  ];

  const canSaveAndProceed = ["1", "6"].includes(
    localStorage.getItem("ApplicationStatusId")
  );
  
  const ApplicationId = localStorage.getItem("ConsumerUserId");
const createPrepopulatedPFS = async () => {
   setLoading(true);
  try {
    const res = await _consumerService.CreatePrepopulatedPDFforPFSNew(ApplicationId);
    console.log(res, "ress")
    if (res?.data?.IsSuccess && res?.data?.Obj?.DocName) {
      const apiFileName = API_HOST + res?.data?.Obj?.DocName;
      setPreUploadedPfsUrl(apiFileName);
       setLoading(false);
    }
  } catch (err) {
    setLoading(false);
    console.error("Error creating prepopulated PFS", err);
  }
};
const clearUploadedField = (field) => {
  setFileList(prev => {
    const updated = { ...prev };
    delete updated[field];
    return updated;
  });

  setFileUrls(prev => {
    const updated = { ...prev };
    delete updated[field];
    return updated;
  });

  setApplicantInfo(prev => {
    const updated = { ...prev };
    delete updated[field];
    return updated;
  });

  form.setFields([
    { name: field, value: undefined, errors: [] }
  ]);
};
const clearFormField = (field) => {
  // clear AntD Form value
  form.setFields([
    {
      name: field,
      value: undefined,
      errors: [],
    },
  ]);

  // clear external state
  setApplicantInfo((prev) => ({
    ...prev,
    [field]: null,
  }));
};

const handlePfsMethodChange = (e) => {
   const value = e.target.value;
   clearUploadedField("levconspfs");
    // clearFormField("creditBureauScore");
  setPfsMethod(value);
  // if (value == "pdfupload") {
  //   createPrepopulatedPFS();
  // }
};

  return (
    <Spin spinning={loading || uploading}>
      <SidebarLayoutConsumer>

        {/* Stepper centered above the card */}
        <div className="stepper-section">
          <LoanApplicationStepper currentStep={1} showApplicationId={true} />
        </div>
        <div className="upload-page-bg">
          <div className="upload-content-wrapper">



            <Card className="upload-main-card" bordered={false}>
              <Title level={1} className="main-title">
                Diligence Upload
              </Title>

              <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
                requiredMark={false}
               initialValues={{
                  ...applicantInfo,
                  pfsMethod: pfsMethod,
                }}                 
              >
                {/* Hidden fields */}
                <Form.Item name="levconspfs" hidden />
                <Form.Item name="levconsfederaltax" hidden />
                <Form.Item name="levconsk1s" hidden />
                <Form.Item name="levconsfundstatement" hidden />
                <Form.Item name="levconscreditreport" hidden />


                   {/* =====================  New Section 1 ===================== */}
                <div className="upload-section-container">

                  <div className="section-header">
                    Section 1 – Financial Information
                    <span className="required-tag"> *</span>
                  </div>

                  {/* Method Selection */}
                  <Form.Item
                  className="pfsMethodFormItem"
                    name="pfsMethod"
                    rules={[
                      { required: true, message: "Application Flow type is required" },
                    ]}
                  >
                 
                    <Radio.Group
                    value={pfsMethod}
                     disabled={!!apiPfsMethod}
                    onChange={(e) => {
                      handlePfsMethodChange(e);
                      form.setFieldsValue({ pfsMethod: e.target.value });
                    }}
                    className="pfs-method-selector"
                  >
                    <Radio.Button value="pdfupload">
                      Upload PFS
                    </Radio.Button>

                    <Radio.Button value="manualentry">
                      Complete Manually
                    </Radio.Button>

                    <Radio.Button disabled value="thirdparty">
                      Use 3rd Party
                    </Radio.Button>
                  </Radio.Group>
                     </Form.Item>
                </div>
                {/* {pfsMethod == "manualentry" && (
                    <div className="upload-section-container">
                       <div className="section-header">
                    Section 1 – CBR Score
                  </div>
                    <Form.Item
                      style={{ marginTop: "25px" }}
                      label={
                        <>
                         <span className="required-tag"> *</span>
                          CBR Score
                        </>
                      }
                      name="creditBureauScore"
                      preserve={true}
                      rules={[
                        { required: true, message: "CBR Score is required" },
                        {
                          validator: (_, value) => {
                            const num = Number(value);
                            if (!Number.isInteger(num)) {
                              return Promise.reject(new Error("Enter a valid integer"));
                            }
                            if (num < 0 || num > 850) {
                              return Promise.reject(new Error("CBR Score must be between 0 and 850"));
                            }
                            return Promise.resolve();
                          },
                        },
                      ]}
                    >
                      <IntegerInput
                        className="w300"
                        maxLength={3}
                        placeholder="Enter CBR Score"
                         onBlur={() => {
      const value = form.getFieldValue("creditBureauScore");
      setApplicantInfo((prev) => ({
        ...prev,
        creditBureauScore: value,
      }));
    }}
                      />
                    </Form.Item>
                    </div>
                 )} */}
                {/* ===================== Section upload using third party ===================== */}
                
                {pfsMethod == "thirdparty" && (
                   <div className="upload-section-container">
                     <div className="upload-card-info mb15">
                     <Text className="upload-card-title">Import Document</Text>
                     </div>
                  <Radio.Group
                  className="thirdpartyProvider-radio-group"                  
                  onChange={(e)=>setThirdPartyProvider(e.target.value)} value={thirdpartyProvider}>
                    <Radio value="stripe">Stripe</Radio>
                    <Radio value="quickbooks">QuickBooks</Radio>
                    <Radio value="bank">Banking Institution</Radio>
                  </Radio.Group>
                   </div>
                    )}
                  {/* ===================== Section upload using pdf ===================== */}
                    {pfsMethod == "pdfupload" && (
                  <div className="upload-section-container manualSelectionHide">
                    {/* <div className="section-header">
                      Section  1 – Personal Financial Statement
                      <span className="required-tag"> *</span>
                    </div> */}

                    <div className="section-body">
                      <Form.Item
                        name="levconspfs"
                        rules={
                          pfsMethod === "pdfupload"
                            ? [{ required: true, message: "Financial Statement (PFS) is required" }]
                            : []
                        }
                      >
                        <PdfDocumentUploadCard

                          title={
                            <>
                             Upload PFS
                              <span className="required-tag">*</span>
                            </>
                          }

                          formats="pdf"
                          // maxSize="350 KB"
                          isDemoDownloadRequired={true}
                          icon={<FileExcelOutlined />}
                          fullWidth
                          fileList={fileList['levconspfs'] || []}
                          uploadedUrl={
                            fileUrls['levconspfs'] ||
                            (applicantInfo['levconspfs'] ? applicantInfo['levconspfs'] : undefined)
                          }
                          uploadProps={{
                            accept: ".pdf",
                            beforeUpload: handleUpload(
                              'levconspfs',
                              'levconspfs',
                              'Personal Financial Statement (PFS)',
                              [".pdf"]
                            ),
                            listType: "picture",
                            maxCount: 1,
                            onRemove: () =>
                              showDeleteConfirm('levconspfs', 'Personal Financial Statement (PFS)'),
                            customRequest: ({ onSuccess }) => onSuccess("ok"),
                            onPreview: (file) => window.open(file.url, "_blank"),
                          }}
                           demoFileUrl= {preUploadedPfsUrl ? preUploadedPfsUrl :""}
                        />
                      </Form.Item>
                    </div>


                  </div>
                )}
                {/* ===================== Section 1 ===================== */}
                 {pfsMethod == "xlsupload" && (
                <div className="upload-section-container">
                  <div className="section-header">
                    Section 1 – Personal Financial Statement
                    <span className="required-tag"> *</span>

                    {/* <span className="required-tag">*</span> */}
                  </div>

                  <div className="section-body">

                    <Form.Item
                      name="levconspfs"
                       rules={
                          pfsMethod === "xlsupload"
                            ? [{ required: true, message: "Financial Statement (PFS) is required" }]
                            : []
                        }
                    >
                      <DocumentUploadCard

                        title={
                          <>
                            Personal Financial Statement (PFS)
                          </>
                        }

                        formats="XLS, XLSX"
                        maxSize="350 KB"
                        isDemoDownloadRequired={true}
                        icon={<FileExcelOutlined />}
                        fullWidth
                        fileList={fileList['levconspfs'] || []}
                        uploadedUrl={
                          fileUrls['levconspfs'] ||
                          (applicantInfo['levconspfs'] ? applicantInfo['levconspfs'] : undefined)
                        }
                        uploadProps={{
                          accept: ".xls,.xlsx",
                          beforeUpload: handleUpload(
                            'levconspfs',
                            'levconspfs',
                            'Personal Financial Statement (PFS)',
                            [".xls", ".xlsx"]
                          ),
                          listType: "picture",
                          maxCount: 1,
                          onRemove: () =>
                            showDeleteConfirm('levconspfs', 'Personal Financial Statement (PFS)'),
                          customRequest: ({ onSuccess }) => onSuccess("ok"),
                          onPreview: (file) => window.open(file.url, "_blank"),
                        }}
                      />
                    </Form.Item>
                  </div>
                </div>
                )}

                        


                {/* ===================== Section 2 ===================== */}
                <div className="upload-section-container">
                  <div className="section-header">
                    Section 2 – Supporting Documents
                  </div>

                  <Row gutter={[24, 24]}>
                    <Col xs={24}>
                      <div className="sub-header-text">
                        A. First 2 Pages of Federal Tax Return

                      </div>

                      <Form.Item
                        name="levconsfederaltax"
                        rules={[{ required: true, message: "First 2 Pages of Federal Tax Return is required" }]}
                        style={{ flex: 1, marginBottom: 0 }}
                      >
                        <DocumentUploadCard

                          title={
                            <>
                              First 2 Pages of Federal Tax Return
                              <span className="required-tag">*</span>

                            </>
                          }

                          formats="PDF, XLS, XLSX"
                          maxSize="350 KB"
                          // icon={<FilePdfOutlined />}
                          fullWidth
                          fileList={fileList["levconsfederaltax"] || []}
                          uploadedUrl={fileUrls["levconsfederaltax"] || applicantInfo?.levconsfederaltax}
                          uploadProps={{
                            accept: ".pdf,.xls,.xlsx",
                            beforeUpload: handleUpload(
                              "levconsfederaltax",
                              "levconsfederaltax",
                              "First 2 Pages of Federal Tax Return",
                              [".pdf", ".xls", ".xlsx"]
                            ),
                            listType: "picture",
                            maxCount: 1,
                            onRemove: () =>
                              showDeleteConfirm(
                                "levconsfederaltax",
                                "First 2 Pages of Federal Tax Return"
                              ),
                            customRequest: ({ onSuccess }) => onSuccess("ok"),
                            onPreview: (file) => window.open(file.url, "_blank"),
                          }}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24}>
                      <div className="sub-header-text">
                        B. K-1s
                        <span className="required-tag ifapplicable">  (if applicable)</span>
                      </div>

                      <Form.Item
                        name="levconsk1s"
                        style={{ flex: 1, marginBottom: 0 }}
                      >
                        <DocumentUploadCard
                          title="K-1s"
                          formats="PDF, XLS, XLSX"
                          maxSize="350 KB"
                          icon={<FilePdfOutlined />}
                          fullWidth
                          fileList={fileList["levconsk1s"] || []}
                          uploadedUrl={fileUrls["levconsk1s"] || applicantInfo?.levconsk1s}
                          uploadProps={{
                            accept: ".pdf,.xls,.xlsx",
                            beforeUpload: handleUpload(
                              "levconsk1s",
                              "levconsk1s",
                              "K-1s",
                              [".pdf", ".xls", ".xlsx"]
                            ),
                            listType: "picture",
                            maxCount: 1,
                            onRemove: () => showDeleteConfirm("levconsk1s", "K-1s"),
                            customRequest: ({ onSuccess }) => onSuccess("ok"),
                            onPreview: (file) => window.open(file.url, "_blank"),
                          }}
                        />
                      </Form.Item>
                    </Col>



                    <Col xs={24}>

                      <div className="sub-header-text">
                        C. Credit Report
                        <span className="required-tag ifapplicable">  (if applicable)</span>
                      </div>
                      <Form.Item name="levconscreditreport" style={{ flex: 1, marginBottom: 0 }}>
                        <DocumentUploadCard
                          title="Credit Report"
                          formats="PDF, XLS, XLSX"
                          maxSize="350 KB"
                          icon={<FilePdfOutlined />}
                          fullWidth
                          fileList={fileList["levconscreditreport"] || []}
                          uploadedUrl={fileUrls["levconscreditreport"] || applicantInfo?.levconscreditreport}
                          uploadProps={{
                            accept: ".pdf,.xls,.xlsx",
                            beforeUpload: handleUpload(
                              "levconscreditreport",
                              "levconscreditreport",
                              "Credit Report",
                              [".pdf", ".xls", ".xlsx"]
                            ),
                            listType: "picture",
                            maxCount: 1,
                            onRemove: () =>
                              showDeleteConfirm("levconscreditreport", "Credit Report"),
                            customRequest: ({ onSuccess }) => onSuccess("ok"),
                            onPreview: (file) => window.open(file.url, "_blank"),
                          }}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} >
                      <div className="sub-header-text">
                        D. Fund Statements / Private Stock Evidence
                        <span className="required-tag ifapplicable">  (if applicable)</span>
                      </div>
                      <Form.Item name="levconsfundstatement" style={{ flex: 1, marginBottom: 0 }}>
                        <DocumentUploadCard
                          title="Fund Statements / Private Stock Evidence"
                          formats="PDF, XLS, XLSX"
                          maxSize="350 KB"
                          icon={<FilePdfOutlined />}
                          fullWidth
                          fileList={fileList["levconsfundstatement"] || []}
                          uploadedUrl={fileUrls["levconsfundstatement"] || applicantInfo?.levconsfundstatement}
                          uploadProps={{
                            accept: ".pdf,.xls,.xlsx",
                            beforeUpload: handleUpload(
                              "levconsfundstatement",
                              "levconsfundstatement",
                              "Fund Statements / Private Stock Evidence",
                              [".pdf", ".xls", ".xlsx"]
                            ),
                            listType: "picture",
                            maxCount: 1,
                            onRemove: () =>
                              showDeleteConfirm(
                                "levconsfundstatement",
                                "Fund Statements / Private Stock Evidence"
                              ),
                            customRequest: ({ onSuccess }) => onSuccess("ok"),
                            onPreview: (file) => window.open(file.url, "_blank"),
                          }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </div>




           

                <LoanApplicationFooter
                  onBack={onBack}
                  submitButtonText="Save And Proceed"
                  submitDisabled={!canSaveAndProceed}
                  showSubmitButton={true}
                />

                {/* <LoanApplicationFooter
                  onBack={onBack}
                  submitButtonText="Save And Proceed"
                /> */}

              </Form>
            </Card>
          </div>
        </div>
      </SidebarLayoutConsumer>
    </Spin>
  );

};

export default DocumentsUpload;